import React, { useEffect, useState } from "react"
import { useStore } from "../store"
import { FabricJSCanvas, useFabricJSEditor } from "fabricjs-react"
import fabric from "fabric"
import AllIcons from "./AllIcons"

const FabricWrapper = () => {
  const { setSVG, currentFace, face, faces } = useStore(state => state)
  const { editor, onReady } = useFabricJSEditor()

  useEffect(() => {
    if (!editor) return
    editor.canvas.width = 128
    editor.canvas.height = 132
  }, [onReady])

  useEffect(() => {
    if (faces.length <= 0) return
    let current = faces[currentFace - 1].fabric
    editor?.canvas.clear()
    current.forEach(obj => {
      editor?.canvas.add(obj)
    })
  }, [face])

  const loadSVG = e => {
    fabric.fabric.loadSVGFromURL(e, (objects, options) => {
      const obj = fabric.fabric.util.groupSVGElements(objects, options)

      obj.active = true
      obj.scale(0.11)

      editor?.canvas.add(obj)
      editor?.canvas.setActiveObject(obj)

      obj.centerV()
      obj.centerH()
      obj.name = e.split("/").pop()

      setSVG(
        editor?.canvas.getActiveObject().toSVG(),
        currentFace,
        obj.type === "text" ? "text" : obj.name,
        editor?.canvas.getObjects()
      )
    })
  }

  const getSVG = async () => {
    if (!editor?.canvas.getActiveObject()) return
    const obj = editor?.canvas.getActiveObject()
    setSVG(
      obj.toSVG(),
      currentFace,
      obj._objects ? obj._objects.map(e => e.name).join(",") : obj.name,
      editor?.canvas.getObjects()
    )
  }

  const centerSVG = () => {
    if (!editor?.canvas.getActiveObject()) return
    const obj = editor?.canvas.getActiveObject()
    obj.centerV()
    obj.centerH()
    setSVG(
      obj.toSVG(),
      currentFace,
      obj._objects ? obj._objects.map(e => e.name).join(",") : obj.name,
      editor?.canvas.getObjects()
    )
  }

  const flipXSVG = () => {
    if (!editor?.canvas.getActiveObject()) return
    const obj = editor?.canvas.getActiveObject()
    obj.flipX = !obj.flipX
    setSVG(
      obj.toSVG(),
      currentFace,
      obj._objects ? obj._objects.map(e => e.name).join(",") : obj.name,
      editor?.canvas.getObjects()
    )
    editor?.canvas.renderAll()
  }

  const removeSVG = () => {
    if (!editor?.canvas.getActiveObject()) return
    const obj = editor?.canvas.getActiveObject()
    editor?.canvas.remove(obj)
    setSVG("", currentFace, "empty face", editor?.canvas.getObjects())
  }

  const duplicateFace = e => {
    if (e.target.value) {
      let current = faces[e.target.value - 1].fabric
      editor?.canvas.clear()
      current.forEach(obj => {
        editor?.canvas.add(obj)
        setSVG(
          obj.toSVG(),
          currentFace,
          obj._objects ? obj._objects.map(e => e.name).join(",") : obj.name,
          editor?.canvas.getObjects()
        )
      })
    }
  }

  return (
    <div className="w-72 h-screen font-title">
      <p className="w-auto text-4xl bg-gray-900  text-white uppercase p-2 font-bold">
        Face {currentFace}
      </p>
      <div onClick={getSVG} className="w-32 h-32 mx-auto ">
        <FabricJSCanvas className="w-32 h-32 bg-gray-200" onReady={onReady} />
      </div>
      <div className="w-full">
        <AllIcons loadSVG={loadSVG} />

        <p className="text-xs p-2">
          Select the icon in the upper canvas to manipulate it.
        </p>
        <button
          onClick={centerSVG}
          className="w-full p-2 m-1 rounded-md text-white center-text bg-gray-600 hover:bg-gray-800 uppercase  font-bold"
        >
          Center Element
        </button>

        <select
          onChange={duplicateFace}
          className="w-full p-2 m-1 rounded-md text-white center-text bg-gray-600 hover:bg-gray-800 uppercase  font-bold"
        >
          <option value="" className="text-center">
            --Duplicate Face--
          </option>
          {faces.map(f => {
            if (f.face === currentFace) return
            if (f.fabric.length === 0) return
            return (
              <option className="Gola" key={f.face} value={f.face}>
                Face {f.face}
              </option>
            )
          })}
        </select>
        <p className="text-xs p-2">Corrects the direction of the normals</p>
        <button
          onClick={flipXSVG}
          className="w-full p-2 m-1 rounded-md text-white center-text bg-gray-600 hover:bg-gray-800 uppercase font-bold"
        >
          Flip Normals
        </button>

        <button
          className="w-full p-2 m-1 rounded-md text-white center-text bg-red-500 hover:bg-red-800 uppercase  font-bold"
          onClick={removeSVG}
        >
          Remove Icon
        </button>
      </div>
    </div>
  )
}

export default FabricWrapper
